import React from 'react';
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Stack,
	Typography,
} from '@mui/material';
import { usePWAInstall } from 'hooks/usePwaInstall';

interface Props {
	open: boolean;
	onClose: () => void;
}

const IOSInstructions = () => (
	<Stack spacing={1} sx={{ mt: 1 }}>
		<Typography variant="body2">
			1. Tap the <strong>Share</strong> icon in Safari.
		</Typography>
		<Typography variant="body2">
			2. Choose <strong>Add to Home Screen</strong>.
		</Typography>
		<Typography variant="body2">
			3. Tap <strong>Add</strong>.
		</Typography>
	</Stack>
);

export const InstallModal: React.FC<Props> = ({ open, onClose }) => {
	const { platform, promptInstall, dismiss } = usePWAInstall();

	const onNotNow = () => {
		dismiss();
		onClose();
	};

	const onInstall = async () => {
		const res = await promptInstall();
		onClose();
		// Optionally: toast based on res
	};

	const isIOS = platform === 'ios';

	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
			<DialogTitle variant={'subtitle1'} fontWeight={'bold'}>
				Install Cathena Dashboard
			</DialogTitle>
			<DialogContent>
				{isIOS ? (
					<>
						<Typography
							variant="subtitle2"
							sx={{ mb: 3 }}
							fontFamily={'Inter'}
							fontSize={14}
						>
							Add this app to your Home Screen for a full‑screen,
							offline‑ready experience.
						</Typography>
						<IOSInstructions />
					</>
				) : (
					<Typography variant="body1">
						Install this app for faster access, offline support, and
						a native‑like experience.
					</Typography>
				)}
				<Box sx={{ mt: 2 }}>
					<Typography
						variant="subtitle2"
						color="text.secondary"
						fontSize={12}
					>
						You can manage this later in your browser settings.
					</Typography>
				</Box>
			</DialogContent>
			<DialogActions style={{ marginBottom: 10 }}>
				<Button
					onClick={onNotNow}
					variant="text"
					style={{ fontFamily: 'Inter' }}
				>
					Not now
				</Button>
				{isIOS ? (
					<Button
						onClick={onClose}
						variant="contained"
						style={{ fontFamily: 'Inter' }}
					>
						Got it
					</Button>
				) : (
					<Button
						onClick={onInstall}
						variant="contained"
						style={{ fontFamily: 'Inter' }}
					>
						Install
					</Button>
				)}
			</DialogActions>
		</Dialog>
	);
};
